import { api } from './BaseService'

export const getCustomers = async () => {
    return await api.get(`/clients`)
}
export const getCustomersBySearch = async (data) => {
    return await api.get(`/clients/autocomplete`, {params:data})
}
export const getCustomerById = async (id) => {
    return await api.get(`/clients/${id}`)
}
export const createCustomer = async (data) => {
    return await api.post(`/clients`, data)
}
export const updateCustomer = async (data) => {
    return await api.put(`/clients/${data?.id}`, data)
}
export const deleteCustomer = async (id) => {
    return await api.delete(`/clients/${id}`)
}
export const getCustomerSize = async (id) => {
    return await api.get(`/clients/size/${id}`)
}
export const updateCustomerSize = async (data) => {
    return await api.put(`/clients/size/${data?.id}`, data?.sizes)
}
